import { signInWithPopup } from "firebase/auth";
import React, { useState } from "react";
import Model from "../../Components/Model";
import FirebaseService from "../../services/FirebaseService";
import { auth, googleProvider } from "./FIrebase";


const formatUsername = (displayName) => {
  if (!displayName) return null;
  return displayName.toLowerCase().replace(/\s+/g, "_");
};

const GoogleSignUp = ({ onSignIn }) => {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // Show username prompt
  const [newUsername, setNewUsername] = useState(""); // Store new username input
  const [errorMessage, setErrorMessage] = useState(""); // For error message
  const [googleResponse, setGoogleResponse] = useState(null); // For error message

  const handleGoogleSignIn = async () => {
    try {
      setLoading(true);

      const result = await signInWithPopup(auth, googleProvider);
      const googleResponse = result.user;

      localStorage.removeItem("userData");

      if (googleResponse) {
        let isExiste = await FirebaseService.isUserExiste({
          firebase_uid: googleResponse.uid,
        });

        if (isExiste?.data?.length > 0) {
          if (!isExiste?.data[0]?.user_name) {
            let isUserNameExiste = await FirebaseService.isUserExiste({
              user_name: formatUsername(googleResponse.displayName),
            });
     
            if (isUserNameExiste) {
              if (isUserNameExiste?.data?.length > 0) {
                setIsModalOpen(true);
                setErrorMessage("Create a New Username");
                setGoogleResponse(googleResponse);
              } else {
                let updateResponse = await FirebaseService.update({
                  user_name: formatUsername(googleResponse.displayName),
                });
                if (updateResponse) {
                  localStorage.setItem("uid", googleResponse.uid);
                  window.location.href = `/admin`;
                }
              }
            } 
          } else {
            localStorage.setItem("uid", googleResponse.uid);
            window.location.href = `/admin`;
          }
        } else {
          let updateResponse = await FirebaseService.upsertUser(
            googleResponse?.uid,
            {
              firebase_uid: googleResponse.uid,
              display_name: googleResponse.displayName,
              email: googleResponse.email,
              photo_url: googleResponse.photoURL,
            }
          );
          if (updateResponse) {
            localStorage.setItem("uid", googleResponse.uid);
            window.location.href = `/admin`;
          }
        }
      }
    } catch (error) {
      console.error("Error during Google Sign-In:", error.message);
      setLoading(false); // Reset loading state on error
    }
  };

  const handleUsernameSubmit = async () => {

    if (newUsername) {
      const formattedUsername = formatUsername(newUsername);
   
      const result = await FirebaseService.isUserExiste({
        user_name: formattedUsername,
      });
      if (result?.data?.length > 0) {
        if (result?.data[0]?.user_name) {
          setErrorMessage("This UserName Not Exists");
        } else {
        }
      } else {
        let res = await FirebaseService.update(googleResponse.uid, {
          user_name: formattedUsername,
        });
        if (res) {
          localStorage.setItem("uid", googleResponse.uid);
          window.location.href = `/admin`;
        }
      }
    }
  };

  return (
    <div className="flex justify-center mt-8">
      <Model
        title="Choose a New Username"
        isOpen={isModalOpen}
        handleSubmit={handleUsernameSubmit}
        onClose={() => setIsModalOpen(false)}
      >
        <input
          type="text"
          value={newUsername}
          onChange={(e) => setNewUsername(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Enter new username"
        />
        {errorMessage && (
          <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
        )}
      </Model>
      <button
        onClick={handleGoogleSignIn}
        className="google-signup-btn p-3 bg-blue-600 text-white rounded-lg flex items-center justify-center transition-all duration-300 hover:bg-blue-700 shadow-lg w-full sm:w-auto"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/1200px-Google_%22G%22_logo.svg.png"
          alt="Google Logo"
          className="w-6 h-6 mr-3"
        />
        {loading ? (
          <span className="font-semibold">Signing In...</span>
        ) : (
          <span className="font-semibold">Sign In with Google</span>
        )}
      </button>
    </div>
  );
};

export default GoogleSignUp;
